import useStorage from './useStorage'

export default function useLocalStorage<T>(key: string, initialValue: T) {
  return useStorage<T>('localStorage', key, initialValue)
}
